module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"transactions":"Buchgungen","noTransactionsAvailable":"Keine Buchungen vorhanden","search":"Suche"},"en":{"transactions":"Transactions","noTransactionsAvailable":"No transactions available","search":"Search"}}')
  delete Component.options._Ctor
}
